import { createRouteDefinition } from '@luna/router';

import { LazyHandoffExchange } from './LazyHandoffExchange';

export const handoffRouteDefinition = createRouteDefinition({
    path: 'handoff/exchange/*',
    element: <LazyHandoffExchange />,
});
